import { render, staticRenderFns } from "./modal_show_scholarship.vue?vue&type=template&id=192b0070&scoped=true"
import script from "./modal_show_scholarship.vue?vue&type=script&lang=js"
export * from "./modal_show_scholarship.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192b0070",
  null
  
)

export default component.exports